import { useEffect, useState } from "react";
import { SharedToggleProps } from "@shared/common/Toggle/types";

const useToggle = <T = string>({
  options,
  selectedOption: propsSelectedOption,
  initialOption,
  onClick,
  disabled,
  setDefaultValue = true,
}: SharedToggleProps<T>) => {
  const initialIndex =
    options?.findIndex((option) => option === initialOption) ??
    (setDefaultValue ? 0 : undefined);
  const [_selectedOption, setSelectedOption] = useState<T | undefined>(
    initialIndex !== undefined ? options?.[initialIndex] : undefined
  );
  const selectedOption = propsSelectedOption ?? _selectedOption;

  useEffect(() => {
    if (initialIndex !== undefined || propsSelectedOption !== _selectedOption) {
      setSelectedOption(
        selectedOption ??
          (initialIndex !== undefined ? options?.[initialIndex] : undefined)
      );
    }
  }, [initialIndex]);

  const changeOption = (option: T) => {
    if (!propsSelectedOption || !onClick) {
      setSelectedOption(option);
    }
    onClick?.(option);
  };

  return {
    selectedOption,
    changeOption: disabled ? undefined : changeOption,
  };
};

export default useToggle;
